/**
 * 组件字段配置
 */

/**
 * 系统来源
 */
export const CHANNEL_TYPE = {
  SYSTEM: 1,  // 系统配置
  CUSTOM: 2,  // 自定义配置
}

/**
 * 组件类型
 */
export const COMPONENT_TYPE = {
  RADIO: 0,
  INPUT: 2,
  CHECKBOX: 1,
  SELECT: 4,
  MUTI_SELECT: 5,
  BMI: 20,
}

// 需要配置数据的组件
export const NEED_CONFIG_DATA = [
  COMPONENT_TYPE.RADIO,
  COMPONENT_TYPE.CHECKBOX,
  COMPONENT_TYPE.SELECT,
  COMPONENT_TYPE.MUTI_SELECT,
]

/**
 * 输入框类型
 */
export const COMPONENT_SUB_TYPE = {
  TEXT: 1,
  NUMBER: 2,
  PHONE: 3,
  DATE: 4,
  ADDRESS: 5
}

/**
 * 组件分类
 */
export const COMPONENT_CATEGORY = {
  BASIC: 'basic',
  SPECIAL: 'SPECIAL',
  PROFITIONAL: 'profitional'
}

// /** 主键 */
// @TableId(type = IdType.AUTO)
// private Long id;

// /** 问卷id */
//         @Excel(name = "问卷id")
// private Long surveyId;

// /** 来源渠道（1：系统配置 2：自定义配置） */
//         @Excel(name = "来源渠道", readConverterExp = "1=：系统配置,2=：自定义配置")
// private Integer channel;

// /** 类型（1：单选框  2：输入框 20：bmi） */
//         @Excel(name = "类型", readConverterExp = "1=：单选框,2=：输入框,2=0：bmi")
// private Integer type;

// /** 输入框类型（1：文本 2：数字 3：手机号 4日期年月日 5：省市区） */
//         @Excel(name = "输入框类型", readConverterExp = "1=：文本,2=：数字,3=：手机号,4=日期年月日,5=：省市区")
// private Integer subType;

// /** 题目标号 */
//         @Excel(name = "题目标号")
// private Integer questNo;

// /** 题目 */
//         @Excel(name = "题目")
// private String question;

// /** 是否必填 */
//         @Excel(name = "是否必填")
// private Boolean required;

// /** 多选配置json */
//         @Excel(name = "多选配置json")
// private String optionsJson;

//         private String remark;

// @Excel(name = "是否有效")
//         private Boolean valid;

// /** 创建时间 */
//         @JsonFormat(pattern = "yyyy-MM-dd HH:mm:ss")
//         @Excel(name = "创建时间", width = 30, dateFormat = "yyyy-MM-dd HH:mm:ss")
// private Date createDate;

// /** 更新时间 */
//         @JsonFormat(pattern = "yyyy-MM-dd HH:mm:ss")
//         @Excel(name = "更新时间", width = 30, dateFormat = "yyyy-MM-dd HH:mm:ss")
// private Date updateDate;

const DATA_DEMO = [
  {
    optionNo: 1,
    optionTxt: '选项1',
  }, {
    optionNo: 2,
    optionTxt: '选项2'
  }
]

const getDefaultData = () => {
  return JSON.parse(JSON.stringify(DATA_DEMO))
}

const COMMON_FIELD = {
  required: false,
  channel: CHANNEL_TYPE.CUSTOM,
  type: COMPONENT_TYPE.INPUT,
  subType: COMPONENT_SUB_TYPE.TEXT,
  questNo: '',
  question: '题目',
  valid: true,
  optionsJson: [],  // 选项值
  remark: '',
  disabled: false,  // 是否禁用
  editable: false,  // 是否可编辑
  needData: false,  // 是否需要数据
  createDate: '',
  updateDate: ''

};

/**
 * 支持的组件
 */
export const COMPONENTS = [
  {
    // 单选题
    ...COMMON_FIELD,
    type: COMPONENT_TYPE.RADIO,
    text: '单选题',
    needData: true,
    optionsJson: getDefaultData(),
    mode: COMPONENT_CATEGORY.BASIC
  },
  {
    // 多选题
    ...COMMON_FIELD,
    type: COMPONENT_TYPE.CHECKBOX,
    text: '多选题',
    optionsJson: getDefaultData(),
    needData: true,
    mode: COMPONENT_CATEGORY.BASIC
  },
  {
    // 下拉选择题
    ...COMMON_FIELD,
    type: COMPONENT_TYPE.SELECT,
    text: '下拉选择题',
    needData: true,
    optionsJson: getDefaultData(),
    mode: COMPONENT_CATEGORY.BASIC
  },
  {
    // 文本输入框
    ...COMMON_FIELD,
    type: COMPONENT_TYPE.INPUT,
    subType: COMPONENT_SUB_TYPE.TEXT,
    text: '文本输入框',
    mode: COMPONENT_CATEGORY.BASIC
  },
  {
    // 数字输入框
    ...COMMON_FIELD,
    type: COMPONENT_TYPE.INPUT,
    subType: COMPONENT_SUB_TYPE.NUMBER,
    text: '数字输入框',
    mode: COMPONENT_CATEGORY.SPECIAL
  }, {
    // 手机号输入框
    ...COMMON_FIELD,
    type: COMPONENT_TYPE.INPUT,
    subType: COMPONENT_SUB_TYPE.PHONE,
    text: '手机号输入框',
    mode: COMPONENT_CATEGORY.SPECIAL
  }, {
    // 日期选择框
    ...COMMON_FIELD,
    type: COMPONENT_TYPE.INPUT,
    subType: COMPONENT_SUB_TYPE.DATE,
    text: '日期选择框',
    mode: COMPONENT_CATEGORY.SPECIAL
  }, {
    // 省市区
    ...COMMON_FIELD,
    type: COMPONENT_TYPE.INPUT,
    subType: COMPONENT_SUB_TYPE.ADDRESS,
    text: '省市区',
    mode: COMPONENT_CATEGORY.SPECIAL
  }, {
    // BMI
    ...COMMON_FIELD,
    type: COMPONENT_TYPE.BMI,
    text: 'BMI',
    mode: COMPONENT_CATEGORY.PROFITIONAL
  }
];

/**
 * 默认的组件
 */
export const DEFAULT_CONPONENTS = [
  {
    // 患者姓名
    ...COMMON_FIELD,
    type: COMPONENT_TYPE.INPUT,
    subType: COMPONENT_SUB_TYPE.TEXT,
    questNo: 1,
    question: '患者姓名',
    channel: CHANNEL_TYPE.SYSTEM,
    disabled: true,
    required: true,
  },
  {
    // 性别
    ...COMMON_FIELD,
    type: COMPONENT_TYPE.RADIO,
    questNo: 2,
    question: '性别',
    channel: CHANNEL_TYPE.SYSTEM,
    disabled: true,
    optionsJson: JSON.parse(JSON.stringify([
      {optionNo: 1, optionTxt: "男"},
      {optionNo: 2, optionTxt: "女"},
    ])),
    required: true,
  },
  {
    // 出生日期
    ...COMMON_FIELD,
    type: COMPONENT_TYPE.INPUT,
    subType: COMPONENT_SUB_TYPE.DATE,
    questNo: 3,
    question: '出生日期',
    channel: CHANNEL_TYPE.SYSTEM,
    disabled: true,
    required: true,
  },
  {
    // 联系方式
    ...COMMON_FIELD,
    type: COMPONENT_TYPE.INPUT,
    subType: COMPONENT_SUB_TYPE.PHONE,
    questNo: 4,
    question: '联系方式',
    channel: CHANNEL_TYPE.SYSTEM,
    disabled: true,
    required: true,
  }
]

